<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Approval Makalah">
            <br>
            <common-training-header :withUser="false"/>
        </a-page-header>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :columns="columns"
                :dataSource="addData"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                bordered>

                <div slot="outline" slot-scope="record" style="text-align: left">
                    <strong>{{ record.title }}</strong><br>
                    {{ record.description }}
                </div>

                <div slot="file" slot-scope="text, record, index">
                    <div v-if="index == 4">
                        <div v-if="items.activity.presentation_file != null">
                            <a-button type="link" size="small" @click="download(items.activity.presentation_file)">
                                <a-icon type="file-ppt" theme="twoTone" two-tone-color="#eb3437" /> Download
                            </a-button>
                        </div>

                        <div v-if="items.activity.presentation_outline_file != null">
                            <a-button type="link" size="small" @click="download(items.activity.presentation_outline_file)">
                                <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                            </a-button>
                        </div>
                    </div>
                    <div v-else-if="index == 5">
                        <div v-if="items.activity.revision_file != null">
                            <a-button type="link" size="small" @click="download(items.activity.revision_file)">
                                <a-icon type="file-ppt" theme="twoTone" two-tone-color="#eb3437" /> Download
                            </a-button>
                        </div>

                        <div v-if="items.activity.revision_outline_file != null">
                            <a-button type="link" size="small" @click="download(items.activity.revision_outline_file)">
                                <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                            </a-button>
                        </div>
                    </div>
                    <div v-else-if="record.files.length > 0">
                        <a-button type="link" size="small" @click="download(record.files[0].file_path)">
                            <a-icon type="file-word" theme="twoTone" two-tone-color="#3452eb" /> Download
                        </a-button>
                    </div>
                </div>

                <div slot="validated_at" slot-scope="text, record, index">
                    <div v-if="index == 4">
                        <div v-if="items.activity.presentation_file != null">
                            {{ moment(items.activity.created_at).format('DD-MM-YYYY HH:mm:ss') }}
                        </div>
                    </div>
                    <div v-else-if="index == 5">
                        <div v-if="items.activity.revision_file != null">
                            {{ moment(items.activity.created_at).format('DD-MM-YYYY HH:mm:ss') }}
                        </div>
                    </div>
                    <div v-else-if="record.files.length > 0">
                        {{ moment(record.files[0].response_time_mentor).format('DD-MM-YYYY HH:mm:ss') }}
                    </div>
                </div>

                <div slot="last_date" slot-scope="text, record, index" style="text-align: left">
                    <div v-if="index == 4">
                        <div v-if="items.activity.presentation_file != null">
                            {{ moment(items.activity.created_at).format('DD-MM-YYYY HH:mm:ss') }}
                        </div>
                    </div>
                    <div v-else-if="index == 5">
                        <div v-if="items.activity.revision_file != null">
                            {{ moment(items.activity.created_at).format('DD-MM-YYYY HH:mm:ss') }}
                        </div>
                    </div>
                    <div v-else-if="record.files.length > 0">
                        {{ moment(record.files[0].approved_at).format('DD-MM-YYYY HH:mm:ss') }}
                    </div>
                </div>
            </a-table>
        </a-card>
    </div>
</template>

<script>
    const columns = [
        {
            key: 'outline',
            title: 'Outline',
            align: 'center',
            scopedSlots: {customRender: 'outline'},
        }, {
            key: 'file',
            title: 'File',
            align: 'center',
            scopedSlots: {customRender: 'file'}
        }, {
            key: 'validated_at',
            title: 'Tanggal Validasi',
            align: 'center',
            width: '180px',
            scopedSlots: {customRender: 'validated_at'}
        } ,{
            key: 'last_date',
            title: 'Tanggal Approve',
            align: 'center',
            width: '180px',
            scopedSlots: {customRender: 'last_date'}
        }
    ]

    export default {
        data() {
            return {
                columns,
                items: {
                    outlines: [],
                    activity: {}
                },
                loading: false
            }
        },
        created() {
            this.getItems()
        },
        computed: {
            addData() {
                this.items.outlines.push(
                    {
                        title: 'PRESENTASI & MAKALAH',
                        description: 'Presentasi & Makalah',
                    }
                )
                this.items.outlines.push(
                    {
                        title: 'REVISI PRESENTASI & MAKALAH',
                        description: 'Revisi Presentasi & Makalah',
                    }
                )
                return this.items.outlines
            }
        },
        methods: {
            getItems() {
                this.loading = true;
                this.$http
                    .get(this.routeUri("api.activity.approved"))
                    .then(response => this.items = response.data)
                    .catch(error => this.handleXhrError(error))
                    .finally(() => (this.loading = false));
            },
            download(url) {
                window.open(window.location.origin + url, '_blank')
            },
        }
    }
</script>
